import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export type StatusSelectionState = 'all' | 'none' | 'some';

export function getStatusSelectionState(
  selectedStatuses: ReadonlyArray<string>,
  statusLabels: ReadonlyArray<string>
): StatusSelectionState {
  if (selectedStatuses.length === 0) {
    return 'none';
  }
  if (selectedStatuses.length === statusLabels.length) {
    return 'all';
  }
  return 'some';
}

export function getStatusMenuButtonLabel(
  selectedStatuses: ReadonlyArray<string>,
  selectionState: StatusSelectionState
): string {
  if (selectionState === 'all') {
    return 'All statuses';
  }
  if (selectionState === 'none') {
    return 'Nothing selected';
  }
  return selectedStatuses.length > 1 ? `${selectedStatuses.length} statuses` : selectedStatuses[0];
}

const SELECT_ALL_MENU_ICONS: Record<StatusSelectionState, BenchlingIconName> = {
  all: 'square-check',
  none: 'square-outline',
  some: 'square-minus',
};

export function getSelectAllMenuIcon(selectionState: StatusSelectionState): BenchlingIconName {
  return SELECT_ALL_MENU_ICONS[selectionState];
}

export function toggleAllStatusSelections<T extends string>(
  selectedStatuses: ReadonlyArray<T>,
  statusLabels: ReadonlyArray<T>
): Array<T> {
  return selectedStatuses.length === statusLabels.length ? [] : [...statusLabels];
}

export function toggleStatusSelection<T extends string>(
  selectedStatuses: ReadonlyArray<T>,
  statusLabel: T,
  isSelected: boolean
): Array<T> {
  return isSelected
    ? [...selectedStatuses, statusLabel]
    : selectedStatuses.filter((status) => status !== statusLabel);
}
